<script>
    import { mapActions, mapMutations, mapState } from 'vuex';
    import CreateAccountForm from './create_account_form';
    import Loader from '~/components/loader/components/loader';
    import ProfileForm from './profile_form';

    export default {
        name: 'user-registration',

        components: {
            CreateAccountForm,
            Loader,
            ProfileForm
        },

        computed: {
            ...mapState('newUserRegistrationForm', {
                accountFormShowing: state => state.accountForm.formShowing,
                profileFormShowing: state => state.profileSettingsForm.formShowing,
                loading: state => state.loading,
            })
        },

        created() {
            this.getFormData();
            this.getPasswordRules();
            this.updateFormShowingStatus({
                formName: 'accountForm',
                showingStatus: true
            });
        },

        methods: {
            ...mapActions('newUserRegistrationForm', {
                getFormData: 'getFormData',
                getPasswordRules: 'getPasswordRules'
            }),

            ...mapMutations('newUserRegistrationForm', {
                updateFormShowingStatus: 'updateFormShowingStatus',
                updateLoading: 'updateLoading',
            })
        }
    }
</script>
<template>
     <div>
         <loader :is-loading="loading.formData"></loader>
         <template v-if="accountFormShowing">
            <create-account-form></create-account-form>
        </template>
        <template v-if="profileFormShowing">
            <profile-form></profile-form>
        </template>
    </div>
</template>
